import { render, staticRenderFns } from "./ReportBug.vue?vue&type=template&id=4ab341b7"
import script from "./ReportBug.vue?vue&type=script&lang=js"
export * from "./ReportBug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports